jQuery(document).ready(function () {
    // setup data attributes on submit button
    jQuery('#phoneNumberModal').on('show.bs.modal', function (event) {
        var button = jQuery(event.relatedTarget);
        // var message = button.data('message');
        const couponID = button.data('couponid');
        jQuery('#sendTextButton').data('couponid', couponID);
    });

    jQuery('#phoneNumberModal').on('shown.bs.modal', function (event) {
       jQuery('#sendTextRecipient').trigger('focus');
    });

    // clear out data on hide
    jQuery('#phoneNumberModal').on('hide.bs.modal', function (event) {
        jQuery('#sendTextRecipient').val('');
        jQuery('#phone-number-help').hide();
    });

    // on click, send text or tell user to enter valid number
    jQuery('#sendTextButton').click(function () {
        // hide warning message
        jQuery('#phone-number-help').hide();
        const recipient = jQuery("#sendTextRecipient").val();

        // if the number isn't 14 digits long (9 digit number + parens and dashes), show warning
        if (recipient.length !== 12) {
            jQuery('#phone-number-help').show();
        } else {
            const couponID = jQuery(this).data('couponid');
            Util.sendCouponSMSText(couponID, recipient);

            // hide the modal
            jQuery('#phoneNumberModal').modal('hide');
            jQuery('#phone-number-help').hide();
        }
    });

    /**
    * Auto fill the phone number fields with dashes
    * Modified version of answer from https://stackoverflow.com/a/43750670/3715362
    **/
    jQuery('#sendTextRecipient')
        .on('change keyup paste', function (e) {
            let output,
            element = jQuery(this),
            input = element.val();

            if(e.keyCode != 8) {
                input = input.replace(/[^0-9]/g, '');
                let area = input.substr(0, 3);
                let pre = input.substr(3, 3);
                let tel = input.substr(6, 4);
                if(area.length === 0) {
                    output = '';
                } else if (area.length > 0 && area.length < 3) {
                    output = area;
                } else if (area.length == 3 && pre.length < 3) {
                    output = area + '-' + pre;
                } else if (area.length == 3 && pre.length == 3) {
                    output = area + '-' + pre + '-' + tel;
                }
                element.val(output);
            }
        })

        .blur(function () {
            $phone = jQuery(this);

            if ($phone.val() === '(') {
                $phone.val('');
            }
        });
});